/**
 * Legacy Tailwind `bg-{token}` classes → hex (mirrors `tailwind.config.js` customer colors).
 * Used only until Mongo `personalization.colorHex` backfill (#248) completes.
 */
export const LEGACY_BRAND_BG_CLASS_TO_HEX: Record<string, string> = {
  'bg-inversimply': '#5271ff',
  'bg-danone': '#002778',
  'bg-prophero': '#2050F6',
  'bg-civitatis': '#f70759',
  'bg-kincode': '#4F46E5',
  'bg-kincode-demo': '#BFC6FF',
  'bg-atento': '#88d2f8',
  'bg-dsmfirmenich': '#000000',
  'bg-navitrans': '#7dc4bb',
  'bg-namencis': '#7B7B7B',
  'bg-jobandtalent': '#04D6C9',
  'bg-taykus': '#040D21',
  'bg-facephi': '#2760fc',
  'bg-coverwallet': '#4D7CBF',
  'bg-isdin': '#CC9359',
  'bg-vicio': '#E43324',
  'bg-amphora': '#FFEB3B',
  'bg-talgo': '#E53935',
  'bg-vertice': '#1c355e',
  'bg-zonafranca': '#2D68AD',
  'bg-wow': '#00ff00',
  'bg-leeters': '#FFFFFF',
  'bg-transfesa': '#FFFFFF',
  'bg-ntt': '#070E27',
  'bg-adviseinc': '#E77822',
  'bg-enel': '#F80A68',
  'bg-cobee': '#1D115B',
  'bg-clicars': '#0379F8',
  'bg-nova': '#000000',
  'bg-ebury': '#3ECBE0',
  'bg-neoris': '#5E5E5E',
  'bg-inversiva': '#156464',
  'bg-ccep': '#F40008',
  'bg-cobre': '#F1F0EC',
  'bg-imperia': '#040F1D',
  'bg-santander': '#ec0000',
  'bg-shakers': '#F4F5F5',
  'bg-kc-black': '#0F172A',
};

/**
 * @param legacyColor - Stored `personalization.color` (e.g. `bg-prophero`, `bg-[#2050F6]`).
 */
export function resolveLegacyBrandClassToHex(legacyColor?: string | null): string | null {
  if (!legacyColor || typeof legacyColor !== 'string') {
    return null;
  }

  const trimmed = legacyColor.trim();
  const mapped = LEGACY_BRAND_BG_CLASS_TO_HEX[trimmed];
  if (mapped) {
    return mapped;
  }

  const arbitraryMatch = /^bg-\[(#[0-9A-Fa-f]{3,8})\]$/.exec(trimmed);
  if (arbitraryMatch) {
    return arbitraryMatch[1];
  }

  return null;
}
